import { InvoiceItemTemplateFormFields } from '~/types/invoiceItemTemplate';

export const initialEmptyValues: InvoiceItemTemplateFormFields = {
  default_item_name: '',
  default_amount: '1',
  default_price: '',
  notes: '',
};
